var map = {
	"./banner/banner.js": [
		12,
		6
	],
	"./breadcrumbs/breadcrumbs.js": [
		13,
		7
	],
	"./bufferband/bufferband.js": [
		14,
		0,
		25,
		8
	],
	"./client/client.js": [
		15,
		0,
		9
	],
	"./content/content.js": [
		16,
		10
	],
	"./feature/feature.js": [
		17,
		0,
		11
	],
	"./footer/footer.js": [
		18,
		12
	],
	"./header/header.js": [
		19,
		5
	],
	"./info/info.js": [
		20,
		13
	],
	"./information/information.js": [
		21,
		14
	],
	"./intro/intro.js": [
		22,
		15
	],
	"./item-card/item-card.js": [
		24,
		16
	],
	"./item/item.js": [
		23,
		0,
		17
	],
	"./more-info/more-info.js": [
		25,
		18
	],
	"./news-detail/news-detail.js": [
		27,
		0,
		19
	],
	"./news/news.js": [
		26,
		20
	],
	"./pagination/pagination.js": [
		28,
		21
	],
	"./results/results.js": [
		29,
		22
	],
	"./search-form/search-form.js": [
		30,
		23
	],
	"./team/team.js": [
		31,
		24
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 6;
module.exports = webpackAsyncContext;